<template>
    <div class="refund-agreement">
         <el-dialog
            title="退费协议"
            :visible="showRefundAgreement"
            width="608"
            custom-class="refund-agreement-dialog"
    　　　　 :append-to-body="true"
            :close-on-click-modal="false"
            @close="closeRefund">
            <div class="refund-content">
                <div class="top" v-for="(item, index) in this.agreement" :key="index">
                    <p class="title">{{item.agreementTitle}}</p>
                    <ul>
                        <li v-for="(list, index) in item.agreementInfo" :key="index">{{list}}</li>
                    </ul>
                </div>
            </div>
            <div class="bottom" slot="footer">
                <a @click="closeRefund">关闭</a>
            </div>
            </el-dialog>
    </div>
</template>

<script>
import { Dialog } from 'element-ui'
export default {
    props: ['agreement', 'showRefundAgreement'],
    components: {
		'el-dialog': Dialog
	},
    data () {
        return {
        }
    },
    methods: {
        closeRefundAgreement () {
            this.$emit('closeRefundAgreement')
        },
        closeRefund () {
            this.$emit('closeRefundAgreement')
        }
    }
}
</script>
<style lang="less">
.refund-agreement-dialog {
    .el-dialog__header{
        height:54px;
        background:rgba(245,245,245,1);
        border-radius:2px 2px 0px 0px;
        padding:0 22px 0 20px;
        line-height: 54px;
        .el-dialog__title{
            font-size: 14px;
            color: #666;
            line-height: 54px;
        }
    }
    .el-dialog__body{
        padding: 30px;
        color: #333;
        max-height: 380px;
        overflow: auto;
        font-size: 14px;
        .refund-content {
            padding: 10px;
            .title {
                font-size:14px;
                font-family:PingFangSC-Medium;
                font-weight:500;
                color:rgba(102,102,102,1);
                margin-bottom: 8px;
            }
            .top {
                margin-bottom: 20px;
            }
        }
    }
    .el-dialog__footer{
        padding: 0;
        height: 80px;
        line-height: 80px;
        text-align: center;
        border-top: 1px solid #DCDCDC;
        .bottom {
            a {
                cursor: pointer;
                display: inline-block;
                width:130px;
                height:40px;
                background:rgba(255,255,255,1);
                border-radius:2px;
                border:1px solid rgba(222,222,222,1);
                text-align: center;
                line-height: 40px;
                color: #333;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// module/order/src/components/dialog/refundAgreement.vue